import MainLayout from './containers/MainLayout'
import albumRoutes from './pages/album/albumRoutes'
import artistRoutes from './pages/artist/artistRoutes'
import playlistRoutes from './pages/playlist/playlistRoutes'
import pisteRoutes from './pages/track/trackRoutes'
import focusRoutes from './pages/focus/focusRoutes'

export default () => ({
	childRoutes: [
		{
			path: '/',
			component: () => window.location = 'http://www.qobuz.com'
		},
		{
			path: '/',
			component: MainLayout,
			childRoutes: [
				...albumRoutes,
				...artistRoutes,
				...playlistRoutes,
				...pisteRoutes,
				...focusRoutes
			]
		},
		{
			path: '*',
			component: () => window.location = 'http://www.qobuz.com'
		}
	]
})



// WEBPACK FOOTER //
// ./src/routes.js